"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEventRelationMock = void 0;
const uuid_1 = require("uuid");
const _1 = require(".");
class UserEventRelationMock extends _1.UserEventRelation {
    constructor(data) {
        const seedData = {
            id: (0, uuid_1.v4)(),
            userId: (0, uuid_1.v4)(),
            eventId: (0, uuid_1.v4)(),
            isApprovedToParticipateInEvent: true,
            isAwaitingVerification: false,
            note: 'I am not available due to personal reasons',
            userDutyPositionForEvent: '',
            remarks: ['A', 'V'],
            availabilityId: (0, uuid_1.v4)(),
            rank: 1,
        };
        super(seedData);
    }
}
exports.UserEventRelationMock = UserEventRelationMock;
